import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { getSegments } from '../../redux/currentSearch/selectors';
import { Div } from '../../layouts';
import { CMS } from '../../utils/CMS/CMS';
import { ConnectedFaresCalendarBottom } from '../Calendar/Context/FaresCalendarBottom';
import { DateUtils, ABUtils } from '../../utils';

export const DatePickerLegends = ({ inline, displayFaresInCalendar, navigateNext, onMoveFocus, showFaresLegend }) => {
    const { t } = useTranslation();
    const { isPricesInCalendarActive: disableHolidayLegend } = ABUtils.getABs();
    const segments = useSelector((state) => getSegments(state));
    const holidayDates = DateUtils.parseArrayOfDates(t('calendar.holidays.country.main'));
    const regionalHolidayDates = DateUtils.parseArrayOfDates(t('calendar.holidays.region.main'));
    const hasHoliday = holidayDates.length > 0 && !disableHolidayLegend;
    const hasRegionalHoliday = regionalHolidayDates.length > 0 && !disableHolidayLegend;
    const hasAnyHoliday = hasHoliday || hasRegionalHoliday;

    const wrapperClass = classNames({
        'odf-space-inner-m odf-flex-container-nogutter': true,
        'odf-flex-container-row': inline,
        'odf-flex-container-column': !inline,
    });

    return (
        <React.Fragment>
            {hasAnyHoliday && (
                <Div className={wrapperClass} backgroundColor="white'">
                    {hasHoliday && (
                        <div className="odf-flex-item-align-start odf-space-outer-left-xs">
                            <div className="odf-flex-container-row odf-flex-container-nogutter">
                                <div className="odf-calendar-legend">
                                    <div className="odf-calendar-day-holiday" />
                                </div>
                                <div className="odf-space-outer-left-s odf-space-outer-right-m">
                                    <span className="odf-text-sm odf-text-mono-color-05">
                                        <CMS id="calendar.holidays.country.caption" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                    {hasRegionalHoliday && (
                        <div className="odf-flex-item-align-start odf-space-outer-left-xs">
                            <div className="odf-flex-container-row odf-flex-container-nogutter">
                                <div className="odf-calendar-legend">
                                    <div className="odf-calendar-day-holiday-region" />
                                </div>
                                <div className="odf-space-outer-left-s odf-space-outer-right-m">
                                    <span className="odf-text-sm odf-text-mono-color-05">
                                        <CMS id="calendar.holidays.region.caption" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                </Div>
            )}
            {displayFaresInCalendar && (
                <ConnectedFaresCalendarBottom
                    segmentId={segments[0].id}
                    navigateNext={navigateNext}
                    onMoveFocus={onMoveFocus}
                    showFaresLegend={showFaresLegend}
                />
            )}
        </React.Fragment>
    );
};

DatePickerLegends.propTypes = {
    inline: PropTypes.bool,
    displayFaresInCalendar: PropTypes.bool,
    navigateNext: PropTypes.bool,
    onMoveFocus: PropTypes.func,
    showFaresLegend: PropTypes.bool,
};

DatePickerLegends.defaultProps = {
    inline: false,
    displayFaresInCalendar: false,
    navigateNext: true,
    onMoveFocus: () => {},
    showFaresLegend: false,
};
